import { render } from "./popupLight.vue?vue&type=template&id=1b08d0bb&scoped=true&ts=true"
import script from "./popupLight.vue?vue&type=script&lang=ts"
export * from "./popupLight.vue?vue&type=script&lang=ts"

import "./popupLight.vue?vue&type=style&index=0&id=1b08d0bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b08d0bb"]])

export default __exports__